import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const impacts = [
  { amount: 'UGX 50,000', effect: 'Funds a week of ICT Training for one student', icon: 'ri-computer-line' },
  { amount: 'UGX 100,000', effect: 'Provides food support for a family for one month', icon: 'ri-seedling-line' },
  { amount: 'UGX 250,000', effect: 'Covers full tailoring course materials for one participant', icon: 'ri-scissors-line' },
  { amount: 'UGX 500,000', effect: 'Funds a microloan that launches a small business', icon: 'ri-bank-line' },
  { amount: 'UGX 1,000,000', effect: 'Sponsors one elderly person\'s care program for a full year', icon: 'ri-user-heart-line' },
  { amount: 'Custom', effect: 'Give any amount — every contribution makes a difference', icon: 'ri-heart-line' },
];

export default function DonatePage() {
  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Hero */}
      <section className="relative min-h-[55vh] flex items-center">
        <div className="absolute inset-0 bg-gradient-to-br from-[#003366] via-[#004488] to-[#ADD8E6]/60" />
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=African%20Uganda%20community%20helping%20hands%20giving%20donation%20support%20hope%20empowerment%20warm%20sunset%20light%20caring%20touch&width=1920&height=900&seq=110&orientation=landscape"
            alt="Donate"
            className="w-full h-full object-cover object-top opacity-30"
          />
        </div>
        <div className="relative z-10 w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-16 text-center">
          <span className="inline-block px-4 py-1.5 bg-[#ADD8E6]/20 border border-[#ADD8E6]/40 rounded-full text-[#ADD8E6] text-xs font-bold uppercase tracking-widest mb-6">
            Support Our Mission
          </span>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
            Your Gift Changes Lives
          </h1>
          <p className="text-white/80 text-lg max-w-2xl mx-auto leading-relaxed">
            Every contribution — no matter the size — directly funds programs that empower communities, educate youth, and restore hope across Uganda.
          </p>
        </div>
      </section>

      <main>
        {/* Impact amounts */}
        <section className="bg-[#F8F8F8] py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-14">
              <span className="text-[#ADD8E6] text-xs font-bold uppercase tracking-widest mb-3 block">Your Impact</span>
              <h2 className="text-3xl sm:text-4xl font-bold text-[#003366] mb-3">What Your Donation Does</h2>
              <p className="text-gray-500 max-w-xl mx-auto">
                See exactly how your generosity translates into real change for families and communities in Uganda.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
              {impacts.map((item) => (
                <div key={item.amount} className="bg-white rounded-xl p-8 text-center hover:-translate-y-1 transition-transform duration-200">
                  <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-[#ADD8E6]/20 rounded-full">
                    <i className={`${item.icon} text-2xl text-[#003366]`} />
                  </div>
                  <p className="text-2xl font-bold text-[#003366] mb-3">{item.amount}</p>
                  <p className="text-gray-500 text-sm leading-relaxed">{item.effect}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Donation Methods */}
        <section className="bg-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-14">
              <span className="text-[#ADD8E6] text-xs font-bold uppercase tracking-widest mb-3 block">How to Give</span>
              <h2 className="text-3xl sm:text-4xl font-bold text-[#003366] mb-3">Donation Methods</h2>
              <p className="text-gray-500 max-w-lg mx-auto">
                We accept donations through multiple convenient channels. Choose the method that works best for you.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Mobile Money */}
              <div className="bg-[#F8F8F8] rounded-2xl p-10">
                <div className="w-16 h-16 flex items-center justify-center bg-[#ADD8E6]/30 rounded-xl mb-6">
                  <i className="ri-smartphone-line text-3xl text-[#003366]" />
                </div>
                <h3 className="text-2xl font-bold text-[#003366] mb-3">Mobile Money</h3>
                <p className="text-gray-500 text-sm mb-6 leading-relaxed">
                  Send your donation quickly and securely using  Airtel Money. Available 24/7 from anywhere in Uganda.
                </p>
                <div className="bg-[#ADD8E6]/20 border border-[#ADD8E6] rounded-xl p-5 space-y-3">
                  <p className="text-xs font-bold text-[#003366] uppercase tracking-wide mb-3">Payment Details</p>
                  
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-500">Airtel Money:</span>
                    <strong className="text-[#003366]">0752239237</strong>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-500">Account Name:</span>
                    
                  </div>
                </div>
                <div className="mt-5 space-y-2">
                  <p className="text-xs text-gray-400 font-semibold uppercase tracking-wide">How to send:</p>
                  <ol className="space-y-1 text-sm text-gray-500 list-decimal list-inside">
                    <li>Dial *165# (MTN) or *185# (Airtel)</li>
                    <li>Select &ldquo;Send Money&rdquo;</li>
                    <li>Enter the number above</li>
                    <li>Enter your donation amount</li>
                    <li>Confirm with your PIN</li>
                    <li>Send us proof via email</li>
                  </ol>
                </div>
              </div>

              {/* Bank Transfer */}
              <div className="bg-[#F8F8F8] rounded-2xl p-10">
                <div className="w-16 h-16 flex items-center justify-center bg-[#ADD8E6]/30 rounded-xl mb-6">
                  <i className="ri-building-line text-3xl text-[#003366]" />
                </div>
                <h3 className="text-2xl font-bold text-[#003366] mb-3">Bank Transfer</h3>
                <p className="text-gray-500 text-sm mb-6 leading-relaxed">
                  Make a direct bank transfer to our organization account. Ideal for larger donations and international transfers.
                </p>
                <div className="bg-[#ADD8E6]/20 border border-[#ADD8E6] rounded-xl p-5 space-y-3">
                  <p className="text-xs font-bold text-[#003366] uppercase tracking-wide mb-3">Bank Account Details</p>
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-500">Bank Name:</span>
                    <strong className="text-[#003366]">ABSA BANK UGANDA LIMITED</strong>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-500">Account Name:</span>
                    <strong className="text-[#003366]">EL-HAI Pentecostal Ministries LTD</strong>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-500">Account No:</span>
                    <strong className="text-[#003366]">6009998886</strong>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-500">Swift Code:</span>
                    <strong className="text-[#003366]">BARCUGKX</strong>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-500">Sort Code:</span>
                    <strong className="text-[#003366]">013447</strong>
                  </div>
                 
                </div>
                <p className="mt-4 text-xs text-gray-400 leading-relaxed">
                  After your transfer, please email your receipt to <a href="mailto:hello@elhaiministries.org" className="text-[#ADD8E6] hover:underline">hello@elhaiministries.org</a> so we can acknowledge your generous gift.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Why Donate */}
        <section className="bg-[#003366] py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
              <div>
                <span className="text-[#ADD8E6] text-xs font-bold uppercase tracking-widest mb-3 block">Why Give</span>
                <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
                  Your Donation is an Investment in Human Dignity
                </h2>
                <p className="text-white/70 text-base leading-relaxed mb-6">
                  El Hai Pentecostal Ministries is a registered NGO in Uganda with full accountability and transparent use of funds. Every donation is directed to our programs — not administrative costs — ensuring maximum impact for every shilling given.
                </p>
                <ul className="space-y-4">
                  {['100% of donations fund community programs', 'Transparent financial reporting', 'Registered NGO in Uganda', 'Regular impact updates to donors'].map((item) => (
                    <li key={item} className="flex items-center gap-3 text-white/80 text-sm">
                      <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-double-line text-[#ADD8E6] text-lg" />
                      </div>
                      {item}
                    </li>
                  ))}
                </ul>
                <div className="mt-8">
                  <a
                    href="mailto:hello@elhaiministries.org"
                    className="inline-block px-7 py-3 bg-[#ADD8E6] text-[#003366] font-bold rounded-lg hover:bg-white transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Contact Us About Giving
                  </a>
                </div>
              </div>
              <div className="rounded-xl overflow-hidden h-80 lg:h-96">
                <img
                  src="https://res.cloudinary.com/dtxnjaa8b/image/upload/q_auto/f_auto/v1775728013/Invest_in_dignity_transform_lives_qar3w3.png"
                  alt="Donation Impact"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
